
export default function NotAuth() {
  return <div style={{ padding: 24, color: "crimson" }}>No autorizado</div>;
}
